<header id="header" tabindex="-1">
  <a *ngIf="logoLink" [routerLink]="logoLink" class="logo" alt="Logo" title="Home">
    <div></div>
  </a>
  <div *ngIf="!logoLink" tabindex="-1" class="logo"></div>


  <ng-container *ngIf="mainContentTemplate">
    <ng-container *ngTemplateOutlet="mainContentTemplate"></ng-container>
  </ng-container>


  <div *ngIf="rightContentTemplate" class="inner-container">
    <ng-container *ngTemplateOutlet="rightContentTemplate"></ng-container>
  </div>
</header>
